import axios from "axios";

const ingestionBaseURL = `/api/v1/ingestion`;

const executeSQL = (
  query,
  currentPage = 1,
  pageSize = 100,
  save_history = false
) =>
  axios.post(`${ingestionBaseURL}/query`, {
    ingestions: { query, page: currentPage, per_page: pageSize, save_history },
  });

const fetchSchemas = () => axios.get(`${ingestionBaseURL}/db`);

const fetchSchemaTables = schema =>
  axios.post(`${ingestionBaseURL}/schema`, { ingestions: { schema } });

const fetchTableColumns = table =>
  axios.post(`${ingestionBaseURL}/table`, { ingestions: { table } });

const fetchPreview = (schema, table) =>
  axios.post(`${ingestionBaseURL}/preview`, { ingestions: { schema, table } });

const fetchSuggestions = () => axios.get(`${ingestionBaseURL}/suggestions`);

const ingestionDataApi = {
  executeSQL,
  fetchSchemas,
  fetchSchemaTables,
  fetchTableColumns,
  fetchPreview,
  fetchSuggestions,
};

export default ingestionDataApi;
